import React, { useEffect, useState, useRef } from "react";
import { message } from "antd";
import WidgetHeader from "../../../components/WidgetHeader";
import { exportChartToCsv } from "../../../utils/widgetExport";
import moment from "moment";
import ReactApexChart from "react-apexcharts";
import { chartHelper } from "../../../utils/chartHelper";
import { buildCartesianChartOptions, buildDonutChartOptions } from "../../../utils/chartOptions";
import * as _ from 'lodash';
import { DATE_FORMAT } from "../../../constants/dateConstants";
import { returnDataArrayObject } from "../../../utils/arrayHelper";

const BoardChartContainer = ({ reportData, charts, availableFields, dataFilters, resourceId, selectedResource, aggregation, widgetName, widgetProperties, hideHeader }) => {

  const [selectedValues, setSelectedValues] = useState([])
  // the element the per-widget Full screen button expands
  const widgetRef = useRef(null);
  const [selectedFilters, setDataFilters] = useState([]);

  const [displayData, setDisplayData] = useState([]);
  const [fieldNames, setFieldNames] = useState([]);

  useEffect(() => {
    if(dataFilters && selectedResource.resourceId === charts.resourceId){
      setDataFilters(dataFilters);
    }
  }, [dataFilters])

  const groupBy = (list, props) => {
    return (list || [])?.reduce((a, b) => {
      (a[b[props]] = a[b[props]] || []).push(b);
      return a;
    }, {});
  };

  var getTotal = (values, fieldName) => Object.keys(values).reduce((a, r) => {
    a[r] = values[r].reduce((acc, val) => acc + Number(val[fieldName]), 0)
    return a;
  }, {});

  const getValueArray = (values) => Object.keys(values).map(val => ({ name: val, value: values[val] }))

  const filterByDate = (filter, date, format) => {
    if (filter.filterType === 'between') {
      return moment(date).isBetween(moment(filter.value1), moment(filter.value2));
    } else if (filter.filterType === 'lte') {
      return moment(moment(date).format(format || DATE_FORMAT)).isSameOrBefore(moment(filter.value).format(format || DATE_FORMAT));
    } else if (filter.filterType === 'lt') {
      return moment(moment(date).format(format || DATE_FORMAT)).isBefore(moment(filter.value).format(format || DATE_FORMAT));
    } else if (filter.filterType === 'gte') {
      return moment(moment(date).format(format || DATE_FORMAT)).isSameOrAfter(moment(filter.value).format(format || DATE_FORMAT));
    } else if (filter.filterType === 'gt') {
      return moment(moment(date).format(format || DATE_FORMAT)).isAfter(moment(filter.value).format(format || DATE_FORMAT));
    } else {
      return moment(moment(date).format(format || DATE_FORMAT)).isSame(moment(filter.value).format(format || DATE_FORMAT))
    }
  }

  const filterByNumber = (filter, value) => {
    if (filter.filterType === 'between') {
      return value >= Number(filter.value1) && value <= Number(filter.value2)
    } else if (filter.filterType === 'lte') {
      return value <= Number(filter.value);
    } else if (filter.filterType === 'lt') {
      return value < Number(filter.value);
    } else if (filter.filterType === 'gte') {
      return value >= Number(filter.value);
    } else if (filter.filterType === 'gte') {
      return value >= Number(filter.value);
    } else if (filter.filterType === 'gt') {
      return value > Number(filter.value);
    } else {
      return value === Number(filter.value)
    }
  };

  const filterByString = (filter, value) => {
    return value === filter.value
  }

  const filterValues = (field) => {
    let results = reportData.data || []
    selectedFilters?.forEach((selectedFilter) => {
      if (field !== selectedFilter.fieldName) {
        results = results.filter((value) => {
          if (selectedFilter.dataType === 'date') {
            const format  = availableFields?.find(
              (f) => f?.fieldName === selectedFilter.fieldName
            )?.format
            return filterByDate(selectedFilter, value[selectedFilter.fieldName], format)
          }
          if (selectedFilter.dataType === 'number') {
            return filterByNumber(selectedFilter, value[selectedFilter.fieldName])
          }
          if (selectedFilter.dataType === 'string') {
            return filterByString(selectedFilter, value[selectedFilter.fieldName])
          }
        });
      };
    })

    return results;
  };

  const formatValues = (array, fieldName) => {
    const reg = /^\d*\.?\d*$/;
    if (array && Boolean(array.length)) {
      if (!reg.test(array[0][fieldName]) && _.isDate(new Date(array[0][fieldName])) && moment(array[0][fieldName]).isValid()) {
        return array.map((value) => Object.assign({}, value, { [fieldName]: moment(value[fieldName])
          .format(availableFields?.find(availbleField => availbleField.fieldName === fieldName)?.format || "YYYY-MM-DD") }))
      }
    }
    return array;
  }

  useEffect(() => {
    // const selectedResults = Boolean(selectedFilters?.length) ? filterValues(charts?.fieldName?.fieldName) : reportData.data;
    const fieldDataFilter = selectedFilters?.find(filter => filter.fieldName === charts?.fieldName?.fieldName)

    if (charts?.fieldName?.fieldName && charts?.groupBy?.fieldName) {
      selectedFilters?.length && fieldDataFilter && Boolean(Object.values(fieldDataFilter).length)
        ? setSelectedValues(
          getValueArray(
            getTotal(
              groupBy(formatValues(displayData, charts?.groupBy?.fieldName), charts?.groupBy?.fieldName)
              , charts?.fieldName?.fieldName
            )).filter(value => filterByNumber(fieldDataFilter, value.value)))
        :
        setSelectedValues(
          getValueArray(
            getTotal(
              groupBy(formatValues(displayData, charts?.groupBy?.fieldName), charts?.groupBy?.fieldName)
              , charts?.fieldName?.fieldName
            )));
    }
  }, [charts, selectedFilters, displayData])


  useEffect(() => {
    let aggregatedData = [];
    let reportDataArr = JSON.parse(JSON.stringify(returnDataArrayObject(reportData))).data; //displayData.data.map(x => x)
    const selectedResults = Boolean(dataFilters?.length) ? filterValues(charts?.fieldName?.fieldName) : reportDataArr || reportData;
    if (
      availableFields &&
      aggregation &&
      aggregation.row &&
      aggregation.row.length > 0
    ) {
      
      Object.preventExtensions(selectedResults);

      selectedResults.forEach((rd, i) => {
        console.log("aggregation DataTable=>", aggregation);

        aggregation.row.forEach((ag, j) => {
          if (ag.rowAggregation[0].operator === "add_c") {
            console.log("====if addc===", rd[ag.rowAggregation[0].fieldName]);
            selectedResults[i][ag?.displayName] =
              Number(rd[ag.rowAggregation[0].fieldName]) +
              Number(ag.rowAggregation[0].const_1);
            console.log(
              selectedResults[i][ag.displayName]
            );
          } else if (ag.rowAggregation[0].operator === "multiply_c") {
            selectedResults[i][ag?.displayName] =
              Number(rd[ag.rowAggregation[0].fieldName]) *
              Number(ag.rowAggregation[0].const_1);
          } else if (ag.rowAggregation[0].operator === "add") {
            selectedResults[i][ag?.displayName] =
              Number(rd[ag.rowAggregation[0].fieldName]) +
              Number(selectedResults[i][ag.rowAggregation[0].field_2]);
          } else if (ag.rowAggregation[0].operator === "multiply") {
            selectedResults[i][ag?.displayName] =
              Number(rd[ag.rowAggregation[0].fieldName]) *
              Number(selectedResults[i][ag.rowAggregation[0].field_2]);
          } else if (ag.rowAggregation[0].operator === "sum") {
            selectedResults[i][ag?.displayName] = ag.rowAggregation[0].fieldNamesList
              .reduce((a, b) => {
                return a + Number(selectedResults[i][b]);
              }, 0)
              .toFixed(2);
          } else if (ag.rowAggregation[0].operator === "avg") {
            selectedResults[i][ag?.displayName] = (
              ag.rowAggregation[0].fieldNamesList.reduce((a, b) => {
                return a + Number(selectedResults[i][b]);
              }, 0) / ag.rowAggregation[0].fieldNamesList.length
            ).toFixed(2);
          } else if (ag.rowAggregation[0].operator === "func") {
            if (ag.rowAggregation[0].calculationStr) {
              console.log(
                "rd[ag.rowAggregation[0]====>>",
                ag.rowAggregation[0],
                "<<<<>>>>",
                rd[ag.rowAggregation[0]["seeing"]]
              );
              let fcn = ag.rowAggregation[0].calculationStr
                .replaceAll(" ", "")
                .replaceAll("@", "Number(rd['") // {field1} - {field2}        @field1 - @field2
                .replaceAll("$", "'])"); // Number(rd['field1']) - Number(rd['field2'])
              selectedResults[i][ag?.displayName] = Number(eval(fcn)).toFixed(2);
              return;
            }
          }
        });
      });


      setDisplayData(selectedResults);
    } else {
      setDisplayData(selectedResults);
    }
  }, [availableFields, aggregation]);


  const formatDate = (array) => {
    return chartHelper(array).numberFormat(2)
  }

  const fetchChart = (chartType) => {
    /* Same options the editor preview draws with - see utils/chartOptions. The widget
       header already carries the name, so the chart draws no title of its own. */
    const isLine = String(chartType).toLowerCase() === 'line';
    const options = buildCartesianChartOptions({
      chartType,
      categories: formatDate(selectedValues?.map((value) => (value.name))),
      xTitle: charts?.groupBy?.fieldName,
      yTitle: charts?.fieldName?.fieldName,
    });

    return (
      <ReactApexChart options={
        options
      } series={[{
        name: charts?.fieldName?.fieldName || 'Value',
        data: formatDate(selectedValues?.map((value) => (value.value)))
      }]} type={isLine ? 'area' : chartType.toLowerCase()}
        /* was a fixed 350 - the widget's card decides the height now, same as the editor
           preview, so a chart fills the space it was laid out with */
        height="100%" />
    )
  }

  /* A chart exports the series it plots — the group-by field and its summed value —
     rather than the rows underneath, because that is what is on screen. */
  const handleDownloadCsv = () => {
    const written = exportChartToCsv({
      rows: reportData?.data ?? reportData,
      groupByField: charts?.groupBy?.fieldName,
      valueField: charts?.fieldName?.fieldName,
      widgetName,
    });
    if (!written) {
      // an incomplete chart config has no series to write, which is a different problem
      // from an empty result and used to look identical
      message.warning(
        charts?.groupBy?.fieldName && charts?.fieldName?.fieldName
          ? "There is no data to download for this widget"
          : "This chart has no fields configured, so there is nothing to download",
      );
    }
  };

  return (
    <div ref={widgetRef} className="board-chart-container">
      {/* A chart always carries its header. Unlike a table, whose columns say what it
          is, a chart is a shape - without the name above it there is nothing on screen
          identifying which resource it came from. widgetName was already passed in and
          simply not used, so the bar disappeared whenever the widget had no download or
          full-screen action. */}
      {/* ...unless the board is a report: it holds this one widget and the page header
          above already carries its name, so the bar only repeated it. */}
      {hideHeader ? null : (
        <WidgetHeader
          title={widgetName ?? ""}
          alwaysShow
          properties={widgetProperties}
          onDownload={handleDownloadCsv}
          fullScreenTargetRef={widgetRef}
        />
      )}
      {/* A pie is drawn as the same donut the editor previews - see utils/chartOptions.

          Both chart types share one body element so the chart fills the card the layout
          gave it, exactly as .widget-content--chart does on the canvas. It used to be a
          bare <div id="chart"> for pies and nothing at all for the rest, which put a
          duplicate id on every pie widget and left the two types sized differently. */}
      <div className="board-chart-body">
        {charts?.chartType === 'Pie' ?
          <ReactApexChart
            options={buildDonutChartOptions({
              labels: formatDate(selectedValues?.map((value) => (value.name))) || [],
            })}
            series={(selectedValues || []).map((value) => Number(value.value))}
            type="donut"
            /* was a fixed 350, which overflowed a short widget and left dead space in a
               tall one - the card sizes it now, same as the editor preview */
            height="100%"
          />
          : charts?.chartType && fetchChart(charts?.chartType)}
      </div>
    </div>
  )

}

export default BoardChartContainer